/* eslint-disable @typescript-eslint/no-explicit-any */
// src/redux/workflows/thunk.ts

import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiClient } from '@/utils/apiClient';
import {
  Form,
  FormDetails,
  FormGroup,
  FormGroupInstanceDetails,
} from './types';

export const fetchForms = createAsyncThunk<
  Form[],
  void,
  { rejectValue: string }
>('workflows/fetchForms', async (_, { rejectWithValue }) => {
  try {
    const response = await apiClient('/data/api/v1/forms/', { method: 'GET' });

    // Return the actual array of forms
    return response.results as Form[];
  } catch (err: any) {
    return rejectWithValue(err.message);
  }
});

export const fetchFormDetails = createAsyncThunk<
  FormDetails,
  string,
  { rejectValue: string }
>('workflows/fetchFormDetails', async (formId, { rejectWithValue }) => {
  try {
    const response = await apiClient(`/data/api/v1/forms/${formId}/`, {
      method: 'GET',
    });
    return response as FormDetails;
  } catch (err: any) {
    return rejectWithValue(err.message);
  }
});

export const fetchFormGroups = createAsyncThunk<
  FormGroup[],
  void,
  { rejectValue: string }
>('workflows/fetchFormGroups', async (_, { rejectWithValue }) => {
  try {
    const response = await apiClient('/data/api/v1/form_groups/', {
      method: 'GET',
    });
    return response as FormGroup[];
  } catch (err: any) {
    return rejectWithValue(err.message);
  }
});

export const fetchFormGroupInstance = createAsyncThunk<
  FormGroup,
  string,
  { rejectValue: string }
>('workflows/fetchFormGroupInstance', async (groupId, { rejectWithValue }) => {
  try {
    const response = await apiClient(`/data/api/v1/form_groups/${groupId}/`, {
      method: 'GET',
    });
    return response as FormGroup;
  } catch (err: any) {
    return rejectWithValue(err.message);
  }
});

export const fetchFormGroupInstanceDetails = createAsyncThunk<
  FormGroupInstanceDetails,
  string,
  { rejectValue: string }
>(
  'workflows/fetchFormGroupInstanceDetails',
  async (groupId, { rejectWithValue }) => {
    try {
      const response = await apiClient(
        `/data/api/v1/form_groups/${groupId}/forms/`,
        { method: 'GET' }
      );
      return response as FormGroupInstanceDetails;
    } catch (err: any) {
      return rejectWithValue(err.message);
    }
  }
);
